export default __webpack_public_path__ + "static/media/chat_edit.c289ff4f.svg";